export const NATURSKADE = {
  nickname: 'PRODUCTS.NATURSKADE.shortname',
  isHidden: true,
  icon: 'naturskade'
};
